module.exports = __webpack_public_path__ + "img/add_btn_icon470.fe110029.svg";